<template>
  <!-- 添加服务类型弹窗 -->
    <el-dialog title="服务类型" :visible="isShowType" @close='close' width='500px'
    :destroy-on-close="true"
    :close-on-click-modal='false'>
        <el-table
          ref="addTable"
          class="global-table"
          v-loading="loading"
          :data="tableData">
          <el-table-column label="类型名称" prop="typeName" min-width="100" align='center'>
            <template slot-scope = "{ row, $index }">
              <div v-if='row.typeId'>
                <template v-if="$index === addLine">
                  <el-input v-model.trim="info.typeName" maxlength="10" placeholder="请输入类型名称"></el-input>
                </template>
                <p v-else>{{row.typeName}}</p>
              </div>
              <template v-else>
                <el-input v-model.trim="info.typeName" maxlength="10" placeholder="请输入类型名称"></el-input>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100" align='center'>
            <template slot-scope="{ row, $index}">
              <!-- 0不是系统默认 -->
              <template v-if="(row.isAdmin === '0' || !row.isAdmin)">
                <template v-if='row.typeId'>
                  <el-button type="text" @click="addUpdate($index, row)" v-if="$ButtonShow('SET_EDT_01')">{{$index === addLine ?"保存" : "编辑" }}</el-button>
                  <el-button type="text" v-if="$index !== addLine && $ButtonShow('SET_DEL_01')" @click="onDelete(row)">删除</el-button>
                </template>
                <template v-else>
                  <el-button type="text" @click="addUpdate($index, row)">保存</el-button>
                </template>
              </template>
            </template>
          </el-table-column>
        </el-table>
      <el-button type="text" @click='addFormNew()' icon='el-icon-plus' v-if="$ButtonShow('SET_ADD_01')">添加服务类型</el-button>
    </el-dialog>
</template>

<script>
export default {
  typeName: 'ServiceType',
  props: {
    isShowType: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      addLine: null,
      loading: false,
      tableData: [],
      info: {
        typeName: ''
      }
    }
  },
  created () {
  },
  watch: {
    isShowType: function (newValue, oldValue) {
      newValue && this.getTypeList()
    },
    deep: true
  },
  computed: {
    initAddForm () {
      return {
        typeName: ''
      }
    }
  },
  methods: {
    validNotEdit (index) {
      if (this.addLine !== null) {
        if (this.addLine !== index) {
          this.$message.warning('请先保存')
        }
        return false
      }
      return true
    },
    getTypeList () {
      this.loading = true
      this.$axios.get(this.$apis.tourist.selectServiceTypeByList).then(res => {
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    addUpdate (index, row) {
      if (this.validNotEdit(index)) {
        this.addLine = index
        this.info = { ...row }
      } else {
        if (this.addLine === index) {
          if (this.info.typeName) {
            delete this.info.isAdmin
            delete this.info.ctime
            delete this.info.isDel
            delete this.info.utime
            const url = this.info.typeId ? this.$apis.tourist.updateServiceType : this.$apis.tourist.insertServiceType
            this.$axios.post(url, this.info).then(() => {
              this.$message.success(this.info.typeId ? '编辑服务类型成功' : '添加服务类型成功')
              this.addLine = null
              this.info = JSON.parse(JSON.stringify(this.initAddForm))
              this.getTypeList()
            })
          } else {
            this.$message.warning('请输入服务类型名称')
          }
        }
      }
    },
    addFormNew () {
      if (this.validNotEdit()) {
        this.info = JSON.parse(JSON.stringify(this.initAddForm))
        this.tableData.push(this.info)
        this.addLine = this.tableData.length - 1
        // 滚动到表格最底部
        this.$nextTick(() => {
          (this.$refs.addTable).bodyWrapper.scrollTop = (this.$refs.addTable).bodyWrapper.scrollHeight
        })
      }
    },
    onDelete (row) {
      if (this.validNotEdit()) {
        this.$confirm(`是否删除服务类型【${row.typeName}】?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post(this.$apis.tourist.deleteServiceType,
            {
              typeId: row.typeId
            }).then(() => {
            this.$message.success('删除成功')
            this.addLine = null
            this.getTypeList()
          })
        })
      }
    },
    close () {
      // 数据清除
      this.addLine = null
      this.$emit('update:isShowType', false)
      this.$emit('updateType')
    }
  }
}
</script>
<style scoped lang="scss">

</style>
